import PropTypes from 'prop-types';
import {Container, Message, Icon} from 'semantic-ui-react';

import {DrupalSiteStatus} from 'helpers/enums';

import BackupCreation from './BackupCreation/BackupCreation';
import BackupRestoration from './BackupRestoration/BackupRestoration';

const Backup = ({projectName, envName, status, isPrimary}) => {
  return (
    <Container>
      {status === DrupalSiteStatus.INITIALIZING && (
        <Message warning>
          <Message.Header>
            <Icon name="warning" />
            This website is initializing
          </Message.Header>
          <p>
            It is not possible to create a new backup for initializing site nor restore it from
            backup. Please wait a couple of minutes and refresh the page. If the process is taking a
            lot of time please open a{' '}
            <a
              href="https://cern.service-now.com/service-portal?id=functional_element&name=drupal-infrastructure"
              target="_blank"
              rel="noreferrer"
            >
              SNOW ticket
            </a>
            .
          </p>
        </Message>
      )}
      {status === DrupalSiteStatus.BROKEN && (
        <Message warning>
          <Message.Header>
            <Icon name="warning" />
            This website has a problem
          </Message.Header>
          <p>
            It is not possible to create a new backup. <br />
            You can try to recover the site by restoring it from a backup or open a{' '}
            <a
              href="https://cern.service-now.com/service-portal?id=functional_element&name=drupal-infrastructure"
              target="_blank"
              rel="noreferrer"
            >
              SNOW ticket
            </a>
            .
          </p>
        </Message>
      )}
      {status === DrupalSiteStatus.OK && isPrimary && (
        <Message info>
          <Message.Header>
            <Icon name="star" color="yellow" />
            Backup policy for the primary environment
          </Message.Header>
          This environment is the primary one and will be backed up automatically every 48 hours.
        </Message>
      )}
      <BackupCreation projectName={projectName} siteName={envName} disabled={status !== 'ok'} />
      <BackupRestoration
        projectName={projectName}
        siteName={envName}
        disabled={status === DrupalSiteStatus.INITIALIZING}
      />
    </Container>
  );
};

Backup.propTypes = {
  projectName: PropTypes.string.isRequired,
  envName: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  isPrimary: PropTypes.bool.isRequired,
};

export default Backup;
